module.exports = __webpack_public_path__ + "img/mail-error.feddd62e.svg";